// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"smarter-way_wrapper__CV_MF","item":"smarter-way_item__-SSlh"};